(function () {
  function mainCode($) {
    $(document).on('Searchanise.ResultsUpdated', function(event, results) {
      $('.snize-color-swatch-box').remove();
    });

  }
  function waitUntilDefined() {
    if (typeof Searchanise !== "undefined" && typeof Searchanise.$ !== "undefined") {
      mainCode(Searchanise.$);
    } else {
      setTimeout(waitUntilDefined, 10);
    }
  }
  waitUntilDefined();
})();